import $ from 'jquery';

// Mount outside responsive tables so overflow and row navigation cannot clip the dialog.
$(document).on('click', '[data-payment-template]', function(event) {
  event.preventDefault();
  event.stopPropagation();
  const template = document.getElementById(this.dataset.paymentTemplate);
  if (!template || document.querySelector('.collection-payment-modal')) return;
  const trigger = this;
  const modal = $(template.content.firstElementChild.cloneNode(true));
  modal.appendTo(document.body);
  modal.on('shown.bs.modal', function() {
    modal.find('select').trigger('focus');
  });
  modal.on('hidden.bs.modal', function() {
    modal.remove();
    if (document.contains(trigger)) trigger.focus();
  });
  modal.modal('show');
});

$(document).on('turbolinks:before-cache', function() {
  $('.collection-payment-modal').modal('hide').remove();
});
